
import "/var/lib/jenkins/workspace/k8s-etmf-web-pro/src/components/PageContainer/index.less?modules";
export default {"container": `container-N7MhWHkJ`}
